import { LEARN_LAUNCH_CONFIG } from '@/constants/learnLaunchConfig';
import { AdvancedToolGateScreen } from '@/features/unified-learning/runtime/components/AdvancedToolGateScreen';
import { ReverseLearningGapSessionScreen } from '@/features/unified-learning/runtime/screens/ReverseLearningGapSessionScreen';

export default function LearnReverseGapSessionRoute() {
  if (!LEARN_LAUNCH_CONFIG.advancedTools.reverse) {
    return <AdvancedToolGateScreen tool="reverse" />;
  }
  return <ReverseLearningGapSessionScreen />;
}
